import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import { Circle } from '../../TheMoshiDifference/TheMoshiDifference'
class index extends Component {
	render() {
		return (
			<div className="page-case-study">
				<Header
					bg="#0f3442"
					title={"Van Master Repairs"}
					image={require('./video.jpg')}
				/>
				<div className="entry-content">
					
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">An evolving business wanting a new look.</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('../../ContactUs/van-masters.png')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">Moshi Moshi provided marketing and business consultancy together with a rebrand, new online presence and digital marketing campaign to help this business reach the next level.</div>
								<p>Assistance included:</p>
								<ul className="with-icons">
									<li>Marketing Strategy</li>
									<li>Naming</li>
									<li>Branding</li>
									<li>Website <a href="https://www.vanmasterrepairs.com.au" target="_blank">www.vanmasterrepairs.com.au</a></li>
									<li>Custom designed for visual impact</li>
									<li>Responsive design to work on all devices</li>
									<li>Animated elements for smooth flow</li>
									<li>Built on React platform which is lightning fast</li>
									<li>Google Adwords Advertising Campaign</li>
									<li>Graphic Design – Flyers, Signage, Business Cards, etc</li>

								</ul>
							</div>
						</div>
					</div>

					<div className="container-fluid example-work">
						<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-6">
							<img src={require('./feature.jpg')} alt="Van Masters Feature" width="100%" />
						</div>
							<div className="col-lg-4">
								<img src={require('./example-1.jpg')} alt="Van Masters Feature" width="100%" />
								<img src={require('./example-2.jpg')} alt="Van Masters Feature" width="100%" />
								<img src={require('./example-3.jpg')} alt="Van Masters Feature" width="100%" />
						</div>
							<div className="col-lg-1"></div>
						</div>
					</div>


					

				</div>


			</div>
		);
	}
}

export default index;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeveDone/VanMasters/index.js